import React from 'react';
import styled from 'styled-components';

const NavContainer = styled.div`
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  padding: 15px;
  margin-bottom: 20px;
  position: sticky;
  top: 0;
`;

const NavTitle = styled.h3`
  color: #2c3e50;
  margin-bottom: 20px;
  font-size: 18px;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
  font-weight: 600;
`;

const NavList = styled.ul`
  list-style-type: none;
  padding: 0;
  margin: 0;
`;

const NavItem = styled.li<{ active?: boolean }>`
  margin-bottom: 10px;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  background-color: ${(props) => (props.active ? '#f0f7ff' : 'transparent')};
  color: ${(props) => (props.active ? '#1a73e8' : '#333')};
  font-weight: ${(props) => (props.active ? 'bold' : 'normal')};
  transition: all 0.2s ease;
  border-left: ${(props) =>
    props.active ? '3px solid #1a73e8' : '3px solid transparent'};

  &:hover {
    background-color: ${(props) => (props.active ? '#f0f7ff' : '#f5f5f5')};
  }
`;

interface DocNavigationProps {
  activeDoc: string;
  onSelectDoc: (docId: string) => void;
}

const DocNavigation: React.FC<DocNavigationProps> = ({
  activeDoc,
  onSelectDoc,
}) => {
  const documents = [
    { id: 'introducao', title: '01 - Introdução' },
    { id: 'nginx', title: '02 - Configuração do Nginx' },
    { id: 'estrutura', title: '03 - Estrutura do projeto' },
    { id: 'react-conceitos-basicos', title: '04 - React: Conceitos Básicos' },
    { id: 'componentes', title: '05 - Componentes' },
    { id: 'rotas', title: '06 - Rotas' },
    { id: 'autenticacao', title: '07 - Autenticação' },
    { id: 'store', title: '08 - Configuração da Store' },
    { id: 'estilizacao', title: '09 - Estilização' },
    { id: 'criando-paginas', title: '10 - Criando novas páginas' },
    { id: 'boas-praticas', title: '11 - Boas Práticas' },
  ];

  return (
    <NavContainer>
      <NavTitle>Documentação</NavTitle>
      <NavList>
        {documents.map((doc) => (
          <NavItem
            key={doc.id}
            active={activeDoc === doc.id}
            onClick={() => onSelectDoc(doc.id)}
          >
            {doc.title}
          </NavItem>
        ))}
      </NavList>
    </NavContainer>
  );
};

export default DocNavigation;
